import { Injectable } from '@angular/core';
import {
  PublicVideo,
  Video,
  VideoAccessVerificationResult,
  VideoData,
  VideoQueryParams,
} from '@core/models/entities/video.models';
import { WlcmPaginatedData } from '@wlcm/common';
import { environment } from '@environment';
import { HttpApi } from './http.api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VideoService {
  private readonly baseUrl: string = environment.apiUrl;

  constructor(private httpApi: HttpApi) {}

  getOne(id: string): Observable<Video> {
    return this.httpApi.get(`${this.baseUrl}/videos/${id}`);
  }

  getVideos(params: VideoQueryParams): Observable<WlcmPaginatedData<VideoData>> {
    return this.httpApi.get<WlcmPaginatedData<VideoData>>(`${this.baseUrl}/videos`, { params: params });
  }

  verifyAccess(id: string): Observable<VideoAccessVerificationResult> {
    return this.httpApi.get(`${this.baseUrl}/videos/check-access/${id}`);
  }

  getPublicVideo(id: string): Observable<PublicVideo> {
    return this.httpApi.get<PublicVideo>(`${this.baseUrl}/videos/stream/${id}`);
  }
}
